import { render, staticRenderFns } from "./FloatingChatroomAccess.vue?vue&type=template&id=9c0e18fc&scoped=true&"
import script from "./FloatingChatroomAccess.vue?vue&type=script&lang=js&"
export * from "./FloatingChatroomAccess.vue?vue&type=script&lang=js&"
import style0 from "./FloatingChatroomAccess.vue?vue&type=style&index=0&id=9c0e18fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c0e18fc",
  null
  
)

export default component.exports